import axios from "axios";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import chavrolet from "../../assets/images/chevrolet-10 1.png";
import noDataFound from "../../assets/images/noDataFound.jpg";
import Van from "../../assets/images/Van.png";
import batary from "../../assets/svg/batary.svg";
import galon from "../../assets/svg/galon.Icon.svg";
import Tire from "../../assets/svg/Tire.svg";
import { TRANSFER_ORDERS_FROM_VEHICLE_TO_VEHICLE } from "../../URLs/Apis";
import InfoItem from "../InfoItem";
import "./OrderDetailsCard.css";

function SelectTheVan({
  showSelectTheVan,
  setShowSelectTheVan,
  slectedtransferOrders,
}) {
  const { user } = useSelector((state) => state.auth);
  const handleCloseAddOrder = () => {
    setShowSelectTheVan(false);
  };

  const transferOrdersFromVehicleToVehicle = () => {
    const headers = {
      Authorization: "Bearer " + user?.token,
    }; // auth header with bearer token

    axios
      .get(TRANSFER_ORDERS_FROM_VEHICLE_TO_VEHICLE, { headers })
      .then((response) => {
        //data message success
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  //Sabmit the orders
  const SabmitTransferOrders = () => {
    setShowSelectTheVan(false);
  };
  return (
    <Modal
      show={showSelectTheVan}
      fullscreen={"xl-down"}
      contentClassName="m-content"
      dialogClassName="m-dialog"
      onHide={handleCloseAddOrder}
    >
      <Modal.Header className="AddStaffModal_header">
        <Modal.Title className="AddStaffModal_title">
          Transfer Orders
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="maindata">
          <div className="titleVanSelect">Select the van</div>
          <div className="mainVans">
            {[1, 2, 3, 4, 5].length > 0 ? (
              <>
                <div className="staff-cards p-0">
                  {[1, 2, 3, 4, 5].map((response) => {
                    return (
                      <div
                        key={response}
                        className="staff-cards-card mainBorder"
                      >
                        <div className="SelectVan-cards-card_title">
                          <div className="SelectVan-cardslogoAname">
                            <div className="imgOfLogoVan">
                              <img src={chavrolet} alt="imgOfLogoVan" />
                            </div>
                            Chevrolet Express
                          </div>
                          <div className="SelectVan-cards-card_Id">
                            Van #0{response}
                          </div>
                        </div>
                        <div>
                          <div className="SelectVan-cards-card_img">
                            <img src={Van} />
                          </div>
                          <div className="vanCapacity">
                            <div className="vanCapacity-head">
                              <span className="vanCapacity-title">
                                Van Capacity<span>(max level)</span>
                              </span>

                              <div>
                                <span className="curntCapacity">3 /</span>
                                <span className="maxCapacity">8 orders</span>
                              </div>
                            </div>
                            <div className="cabacityBar"></div>
                          </div>
                          <div className="vanCapacity">
                            <div className="vanCapacity-head">
                              <span className="vanCapacity-title">
                                Working hours
                              </span>
                              <div>
                                <span className="curntCapacity">6 /</span>
                                <span className="maxCapacity">8 hours</span>
                              </div>
                            </div>
                            <div className="cabacityBar"></div>
                          </div>
                        </div>
                        <div>
                          <InfoItem
                            label="Available Services"
                            value={
                              <>
                                <img src={galon} alt="galon.Icon.svg" />
                                <img src={Tire} alt="batary.svg" />
                                <img src={batary} alt="Tire.svg" />
                              </>
                            }
                          />
                          <InfoItem
                            label="Supervisor"
                            value={response.email || "Ali Samir"}
                          />
                          <InfoItem
                            label="Driver"
                            value={response.phone_number || "Sameh Ahmed"}
                          />
                          <InfoItem
                            label="Engineer"
                            value={response.email || "Osama Mohamed "}
                          />
                          <InfoItem
                            label="Technician"
                            value={response.email || "Mohamed Ragab "}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <div className="noStaff-cards mainBorder">
                <img
                  className="noStaffImg"
                  src={noDataFound}
                  alt="No staff members"
                />
              </div>
            )}
          </div>
        </div>
        <div className="OrdersTable-footer">
          <button
            onClick={() => {
              setShowSelectTheVan(false);
            }}
            className="ordersCancelTable"
          >
            Cancel
          </button>
          <button onClick={SabmitTransferOrders} className="ordersSaveTable">
            Save
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SelectTheVan;
